import api from '../services/api'
import _ from 'lodash'
import moment from 'moment'

const parseReportResponse = (response) => {
  const data = response.data
  data.push({
    product: 'Total',
    totalCallCount: response.data.reduce((memo, i) => (memo + Number(i.totalCallCount)), 0),
  })
  return data
}

const parseChartResponse = (response, payload) => {
  const colors = {
    PricingTool: '#77aedc',
    VarianceTable: '#154f83',
    LucidComm: '#3980ab',
    Lookup: '#4482D3FF',
  }
  const products = {}
  response.data.forEach((i) => {
    products[i.product] = []
  })

  const groupedLabel = _.groupBy(response.data, 'datetime')

  Object.values(groupedLabel).forEach((v) => {
    Object.keys(products).forEach((p) => {
      const item = v.find((i) => i.product === p)
      products[p].push(item ? item.totalCallCount : 0)
    })
  })
  return {
    labels: Object.keys(groupedLabel)
      .map((i) => (moment(i).format(payload === 'week' ? 'M/D/YYYY' : 'M-YY'))),
    datasets: Object.entries(products).map(([key, value]) => {
      return {
        label: key,
        data: value,
        backgroundColor: colors[key] || '#62778f',
      }
    }),
  }
}

export default {
  actions: {
    loadDashboardApiReport ({ commit }, payload) {
      return api.loadDashboardApiCallReport(payload).then((response) => parseReportResponse(response))
    },
    loadDashboardApiChart ({ commit }, payload) {
      return api.loadDashboardApiCallChart(payload).then((response) => parseChartResponse(response, payload))
    },

    loadDashboardProductReport ({ commit }, payload) {
      return api.loadDashboardProductCallReport(payload).then((response) => parseReportResponse(response))
    },
    loadDashboardProductChart ({ commit }, payload) {
      return api.loadDashboardProductCallChart(payload).then((response) => parseChartResponse(response, payload))
    },
  },
  namespaced: true,
}
